import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {contentToText} from '../../../utils/helpers.jsx';
import PieChart from '../../charting/PieChart/PieChart.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
import Inset from '../../Inset/Inset.jsx';


let componentRegistry = {}

export default (props) => {
    return (<div className="container body-text">
        <div className="section">
            <div className="row">
                <div className="col l8">
                    <h3>Shipping and You</h3>
                    <Markdown>
                        {contentToText(content['shipping-and-you'],componentRegistry)}
                    </Markdown>
                </div>
            </div>
        </div>
    </div>)   
}




// WEBPACK FOOTER //
// ./src/js/components/special/YouIntro/YouIntro.jsx